export const getRoleName = (role: Role) => {
  if (role === 'admin') {
    return 'Administrador';
  }
  if (role === 'employee') {
    return 'Empleado';
  }
  return '';
};
